export default "__VITE_ASSET__DOWkyBmu__"